import { createActions } from 'redux-actions';

export const addCallerActions = createActions(
  'ADD_CALLER_CALL_REQUEST',
  'ADD_CALLER_CALL_REQUEST_SUCCEEDED',
  'ADD_CALLER_CALL_REQUEST_FAILED',

  'ADD_CALLER_REMOVE_CALLER_REQUEST',
  'ADD_CALLER_REMOVE_CALLER_REQUEST_SUCCEEDED',
  'ADD_CALLER_REMOVE_CALLER_REQUEST_FAILED',

  'ADD_CALLER_SET_ON_HOLD_REQUEST',
  'ADD_CALLER_SET_ON_HOLD_REQUEST_SUCCEEDED',
  'ADD_CALLER_SET_ON_HOLD_REQUEST_FAILED',

  'ADD_CALLER_GET_USERS_BY_QUERY',
  'ADD_CALLER_GET_USERS_BY_QUERY_SUCCEEDED',
  'ADD_CALLER_GET_USERS_BY_QUERY_FAILED',

  'ADD_CALLER_MODAL_CLOSE',
  'ADD_CALLER_MODAL_OPEN',

  'ADD_CALLER_RESET_USERS',
);
